/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const keyPrefix = "supplier_system";
export function getItem(key: string): any {
  let res = null;
  try {
    res = JSON.parse(localStorage.getItem(keyPrefix + key) + "");
  } catch (err) {
    res = localStorage.getItem(keyPrefix + key);
  }
  return res;
}
export function setItem(key: string, value: any): void {
  localStorage.setItem(keyPrefix + key, JSON.stringify(value));
}
export function removeItem(key: string) {
  localStorage.removeItem(keyPrefix + key);
}
